import { type Assign, type HTMLProps, Toast } from "@ark-ui/solid";
import type { ComponentProps } from "solid-js";
import { tv, type VariantProps } from "tailwind-variants";
import { createStyleContext } from "~/solidJs/shared/helpers/create-style-context";

const toast = tv(
	{
		base: "toast",
		defaultVariants: { toastType: "default" },
		slots: {
			root: "flex w-max items-center justify-center gap-2 rounded-xl p-4 text-white text-xs",
			title: "font-medium",
			description: "text-xs opacity-90",
			closeTrigger: "",
			actionTrigger:
				"mt-2 cursor-pointer rounded-md bg-white/20 px-3 py-1 font-medium text-xs transition-colors hover:bg-white/30"
		},
		variants: {
			toastType: {
				default: {
					root: "bg-[#2E2D2D]"
				},
				error: {
					root: "bg-status-accent-error"
				},
				success: {
					root: "bg-status-accent-positive"
				},
				warning: {
					root: "bg-background-orange"
				},
				info: {
					root: "bg-blue-500"
				}
			}
		}
	},
	{ twMerge: true }
);

const { withRootProvider, withContext } = createStyleContext(toast);

export type ToastVariationProps = VariantProps<typeof toast>;

export type RootProps = ComponentProps<typeof Root>;
export const Root = withRootProvider<Assign<Toast.RootProps, ToastVariationProps>>(Toast.Root);

export const ActionTrigger = withContext<Assign<HTMLProps<"button">, Toast.ActionTriggerBaseProps>>(
	Toast.ActionTrigger,
	"actionTrigger"
);

export const CloseTrigger = withContext<Assign<HTMLProps<"button">, Toast.CloseTriggerBaseProps>>(
	Toast.CloseTrigger,
	"closeTrigger"
);

export const Description = withContext<Assign<HTMLProps<"div">, Toast.DescriptionBaseProps>>(
	Toast.Description,
	"description"
);

export const Title = withContext<Assign<HTMLProps<"div">, Toast.TitleBaseProps>>(
	Toast.Title,
	"title"
);

export { ToastContext as Context } from "@ark-ui/solid";
